import { types } from 'core/types';

import { ComponentBlock } from '@types';

import { component } from './component';
import { RichTextEditorProps, RichTextEditorTriggers } from './index';

export const block: ComponentBlock<'richTextEditor', RichTextEditorProps, RichTextEditorTriggers> = {
  id: 'richTextEditor',
  render: component,
  props: {
    name: {
      type: types.string,
    },
    label: {
      type: types.string,
    },
    placeholder: {
      type: types.string,
    },
    size: {
      type: types.string,
    },
    isInvalid: {
      type: types.boolean,
    },
    value: {
      type: types.string,
    },
    readOnly: {
      type: types.boolean,
    },
  },
  triggers: {
    onBlur: {
      name: 'On blur',
      description: 'When the control is unfocused',
    },
  },
};
